import RecentRegNums from "../components/RecentRegNums";
import TopSelling from "../components/TopSelling";
import RecentActivity from "../components/RecentActivity";
import BudgetReport from "../components/BudgetReport";
import WebSiteTraffic from "../components/WebSiteTraffic";
import NewsAndUpdate from "../components/NewsAndUpdate";
import { DonutChart } from "../components/DonutChart";
import DashboardCard from "../components/DashboardCard";
import { useContext, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useEffect } from "react";
import * as request from '../lib/lib'
import { FormatDate } from "../../utils/RegisterApplicationBodyFormatter";
import { AdminContext } from "../../contexts/AdminContext";

export function DashBoard() {
    const { user } = useContext(AuthContext)
    const { getRankedCount,
        rankedCount,
        acceptedCount,
        canceledCount,
        getAcceptedCount,
        getCanceledCount,
        getLastFiveRegs,
        last5RegNums,
        recentActivity,
        getActions,
        isConnectionOpen
    } = useContext(AdminContext);

    const [ranking, setRanking] = useState(null);

    useEffect(() => {
        request.get(process.env.REACT_APP_BACKEND_URL + 'Ranking/GetRecentRanking')
            .then((data) => {
                setRanking(data);
            })

        document.title = `Начало`;

    }, [])

    useEffect(() => {
        if (ranking && isConnectionOpen) {
            getRankedCount(ranking.klasiranE_ID, user.role == 'Director' ? user.school.id : null);
            getAcceptedCount(ranking.klasiranE_ID, user.role == 'Director' ? user.school.id : null);
            getCanceledCount(ranking.klasiranE_ID, user.role == 'Director' ? user.school.id : null);
            getLastFiveRegs(user.role == 'Director' ? user.school.id : null);
            if (user.role == 'Admin' || user.role == 'SuperAdmin') {
                getActions();
            }
        }
    }, [ranking, isConnectionOpen])

    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Начало</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="index.html">Начало</a></li>
                        <li className="breadcrumb-item active">Табло за класиране {ranking && FormatDate(new Date(ranking.klaS_DATE))}</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">
                        <div className="row">
                            <DashboardCard cardTitle='Класирани' school={`${user.role == 'Director' ? user.school.shortName : 'Всички училища'}`} icon='bi bi-graph-up' value={rankedCount} color="text-primary" />
                            <DashboardCard cardTitle='Записани' school={`${user.role == 'Director' ? user.school.shortName : 'Всички училища'}`} icon='bi bi-check-circle' value={acceptedCount} color="text-success" />
                            <DashboardCard cardTitle='Отказани' school={`${user.role == 'Director' ? user.school.shortName : 'Всички училища'}`} icon='bi bi-x-circle' value={canceledCount} color="text-danger" />

                            {/* <Reports /> */}
                            {/*<RecentSales />*/}
                            {/*<TopSelling />*/}
                        </div>
                    </div>


                    <div className="col-lg-12">
                        {/*<BudgetReport />*/}
                        <div className="row">
                            <RecentRegNums regNums={last5RegNums} school={`${(user.role == 'Director' && ranking && ranking.iS_FINAL == 1) ? ` класирани в ${user.school.shortName}` : (user.role == 'Director' && ranking && ranking.iS_FINAL == 0) ? ` с първо желание ${user.school.shortName}` : 'Всички училища'}`} />
                            {(user.role == 'Admin' || user.role == 'SuperAdmin') && <RecentActivity actions={recentActivity} />}

                            {/*<DonutChart index={1} />*/}
                            {/*<DonutChart index={2} />*/}
                        </div>
                        {/**/}
                        {/*<NewsAndUpdate />*/}
                    </div>

                </div>

            </section>

        </main>
    )
}

export default DashBoard;